import { Slide as PRCSlide, Slider as PRCSlider } from 'pure-react-carousel'
import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const CarouselSlider = styled(PRCSlider)`
  height: 100%;
  overflow: hidden;

  .carousel__slider-tray-wrapper {
    height: 100%;
  }

  .carousel__slider-tray {
    height: 100%;
  }

  .carousel__image--with-background {
    background-position: center;
  }
`

export const SlideVisibilityTarget = styled.div`
  height: 2px;
  width: 2px;
  visibility: hidden;
  display: flex;
  position: absolute;

  /* Note: need 1px padding. Otherwise slides adjacent to the current slide would be rendered */
  left: 1px;
  width: calc(100% - 2px);
`

export const CarouselSlide = styled(PRCSlide)<{ $overflowY?: string }>`
  background: ${o => o.theme.color.deprecated.stoneLighter};
  user-select: none;
  overflow-y: ${o => o.$overflowY};

  /* Note: this fixes the previous/next slide image beleeding into the main image on the left/right side */
  padding: 0 1px;

  img,
  video {
    ${fromMd} {
      object-fit: contain;
      width: unset;
    }
  }

  .carousel__inner-slide {
    /* Note: default value set by pure-react-carousel is "position: unset"*/
    /* Hence the need for "!important" */
    position: relative !important;
  }
`
